import { render, staticRenderFns } from "./UserDataList.vue?vue&type=template&id=25d502f6&scoped=true&"
import script from "./UserDataList.vue?vue&type=script&lang=js&"
export * from "./UserDataList.vue?vue&type=script&lang=js&"
import style0 from "./UserDataList.vue?vue&type=style&index=0&id=25d502f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d502f6",
  null
  
)

export default component.exports